import * as storage from 'lib/storage'
import { FormErrors } from 'redux-form'
import { normalizePhone } from 'lib/normalize'
import { ImmutableMap } from 'types/common'
import { InfoType } from 'pages/Recruiter/Candidates/AddEditProfile/types'

const API_URL = process.env.REACT_APP_API_PATH_DOWNLOADS

export function persistToken(tokens: string) {
  storage.setStorageType(storage.LOCAL_STORAGE)
  storage.setStorageItem('tokens', JSON.stringify(tokens))
}

type CheckSignUpType = (message?: string) => FormErrors
export const checkSignUp: CheckSignUpType = message => {
  return { email: message }
}

export const transformUser = (data: ImmutableMap<InfoType>) => {
  return data
    .update('avatar', (val: string) => (val ? `${API_URL}/${val}` : undefined))
    .update('phone', normalizePhone(data.get('phonePrefix')))
}

export const checkInviteRecruiter = (data: {
  errors: Array<{ context: { key: number }; message: string }>
}) => {
  const errors: { [x: string]: string } = {}
  if (data && data.errors) {
    data.errors.forEach(({ context: { key }, message }) => {
      errors[key] = message
    })
  }
  return errors
}

interface ReduxFormErrors {
  [key: string]: string
}

export const mapApiErrorToReduxForm = (data: any): ReduxFormErrors => {
  const out: ReduxFormErrors = {}

  // 1) Joi-like errors array: [{ message, path: [...] }]
  if (data && data.errors && Array.isArray(data.errors)) {
    data.errors.forEach((e: any) => {
      const msg = e && e.message
      const path = e && e.path

      if (!msg) return

      // field name is usually last segment of path
      if (Array.isArray(path) && path.length > 0) {
        const last = path[path.length - 1]

        // if last is string -> treat as field name
        if (typeof last === 'string') {
          out[last] = String(msg)
          return
        }
      }

      // fallback: form-level
      if (out._error) out._error = out._error + '\n' + String(msg)
      else out._error = String(msg)
    })
  }

  // 2) Nest HttpException format: { statusCode, message, error }
  if (Object.keys(out).length === 0) {
    const msg2 = data && data.message

    if (typeof msg2 === 'string') {
      out._error = msg2
    } else if (Array.isArray(msg2)) {
      out._error = msg2.join('\n')
    }
  }

  // absolute fallback
  if (Object.keys(out).length === 0) {
    out._error = 'Something went wrong. Please try again.'
  }

  return out
}
